import clsx from 'clsx'
import { CSSProperties, ReactNode } from 'react'
import { TSizeAll } from 'src/types'
import styles from './Chip.module.scss'

export const Chip = ({
  children,
  icon,
  style,
  size,
  className,
  onRemove,
  allowMultiple,
}: {
  children: ReactNode
  style?: CSSProperties
  size: TSizeAll
  icon?: ReactNode
  className?: string
  onRemove?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void
  allowMultiple?: boolean
}) => (
  <div className={clsx('mui-select-chip', styles.wrapper, styles[size], className)} style={style}>
    <div className={clsx('mui-select-chip-content', styles.content)}>
      {icon}
      <div className={clsx('mui-select-chip-children', styles.children)}>{children}</div>
      {allowMultiple && <RemoveIcon onClick={onRemove} />}
    </div>
  </div>
)

const RemoveIcon = ({
  onClick,
}: {
  onClick?: (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => void
}) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles.close}
    role="button"
    onClick={onClick}
  >
    <path
      d="M7.51562 1.53906L5.05469 4L7.51562 6.48438C7.82031 6.76562 7.82031 7.25781 7.51562 7.53906C7.23438 7.84375 6.74219 7.84375 6.46094 7.53906L4 5.07812L1.51562 7.53906C1.23438 7.84375 0.742188 7.84375 0.460938 7.53906C0.15625 7.25781 0.15625 6.76562 0.460938 6.48438L2.92188 4L0.460938 1.53906C0.15625 1.25781 0.15625 0.765625 0.460938 0.484375C0.742188 0.179688 1.23438 0.179688 1.51562 0.484375L4 2.94531L6.46094 0.484375C6.74219 0.179688 7.23438 0.179688 7.51562 0.484375C7.82031 0.765625 7.82031 1.25781 7.51562 1.53906Z"
      fill="currentColor"
    />
  </svg>
)
